import React from 'react';

interface ThaiYearInputProps {
  value: string;
  onClick: React.MouseEventHandler<HTMLInputElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
  placeholder: string;
  id: string;
  name: string;
  className?: string;
  'aria-labelledby'?: string;
}

const ThaiYearInput = React.forwardRef<HTMLInputElement, ThaiYearInputProps>(
  (
    {
      value,
      onClick,
      onChange,
      onBlur,
      placeholder,
      id,
      name,
      className,
      'aria-labelledby': ariaLabelledBy,
    },
    ref
  ) => {
    let displayValue = value;

    // Show Thai Buddhist year if value is valid
    if (value && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const [day, month, year] = value.split('/');
      const thaiYear = parseInt(year, 10) + 543;
      displayValue = `${day}/${month}/${thaiYear}`;
    }

    return (
      <div className="react-datepicker__input-container react-datepicker__view-calendar-icon">
        {/* Conditionally show calendar icon only when no date is selected */}
        {!value && (
          <i className="bi bi-calendar react-datepicker__calendar-icon calendar-icon react-datepicker-ignore-onclickoutside" />
        )}

        {/* Input Field */}
        <input
          ref={ref}
          type="text"
          id={id}
          name={name}
          placeholder={placeholder}
          className={`date-picker react-datepicker-ignore-onclickoutside ${className || ''}`}
          value={displayValue || ''}
          onClick={onClick}
          onChange={onChange}
          onBlur={onBlur}
          aria-labelledby={ariaLabelledBy}
        />

        {/* Clear (X) Button */}
        {value && (
          <button
            type="button"
            className="react-datepicker__close-icon"
            aria-label="Close"
            tabIndex={-1}
            onClick={() => {
              const event = {
                target: {
                  value: '',
                },
              } as unknown as React.ChangeEvent<HTMLInputElement>;
              onChange?.(event);
            }}
          />
        )}
      </div>
    );
  }
);

ThaiYearInput.displayName = 'ThaiYearInput';

export default ThaiYearInput;
